import * as angular from 'angular';
import * as _ from "lodash";
import {apsEvents} from "../../shared/dto/aps.events";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {StateParams} from "../../common";
import {Strings} from "../../shared/config/constant.module";
import DateUtilityService from "../../services/utility/dateutility.service";
import CheckListInstancesServiceName, {CheckListInstancesService} from "../../services/checkLists/checkListInstances.service";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import CheckListInstancesHubName, {CheckListInstancesHub, CheckListInstancesHubCreator} from "../../services/checkLists/checkListInstances.hub";
import FillOutCheckListName, {openFillOutCheckList} from "./fillOutCheckList.controller";

let requires = [CheckListInstancesServiceName, ShopServiceName, CheckListInstancesHubName, FillOutCheckListName];

interface UnfinishedCheckListsController {
  list: apsViewModels.CheckListInstanceListItem[];
  loading: boolean;
  formatTime(time): string;
  open(checkListInstance: apsViewModels.CheckListInstanceListItem): void;
  getStatusName(status: apsEnums.CheckListStatus): string;
}

class UnfinishedCheckListsCtrl implements UnfinishedCheckListsController {
  list: apsViewModels.CheckListInstanceListItem[];
  loading: boolean;
  private plantId: string;
  private shopId: string;
  private shop: apsViewModels.ShopConfiguration;
  private timeZoneId: string;
  private $modal: mm.foundation.modal;
  private checkListInstancesService: CheckListInstancesService;
  private hub: CheckListInstancesHub;
  private $scope: angular.IScope;
  private $timeout: angular.ITimeoutService;

  constructor(
    checkListInstancesService: CheckListInstancesService,
    $modal: mm.foundation.modal,
    $q: angular.IQService,
    shopService: ShopService,
    checkListInstancesHubCreator: CheckListInstancesHubCreator,
    $scope: angular.IScope,
    $timeout: angular.ITimeoutService,
    $stateParams: StateParams) {
    this.plantId = $stateParams.plantId;
    this.shopId = $stateParams.shopId;
    this.timeZoneId = Strings.DEFAULT_TIMEZONE;
    this.$modal = $modal;
    this.loading = true;
    this.checkListInstancesService = checkListInstancesService;
    this.$scope = $scope;
    this.$timeout = $timeout;

    var shopPromise = shopService
      .getShopConfiguration(this.shopId)
      .then((result) => {
        this.shop = result;
        this.timeZoneId = result.timeZoneId;
      }
    );

    var instancesPromise = checkListInstancesService
      .getUnfinishedInstances(this.plantId, this.shopId)
      .then((data) => {
        this.list = _.filter(data, (instance) => checkListInstancesService.isAuthorizedForCurrentPlant(instance));
      });

    $q.all([shopPromise, instancesPromise]).then(() => this.loading = false);

    this.hub = checkListInstancesHubCreator.createCheckListInstancesHub(
      this.plantId, this.shopId,
      (updated) => this.handleUpdated(updated),
      (instance) => this.handleInstance(instance));

    this.$scope.$on('$destroy', () => {
      if (this.hub) {
        this.hub.uninitialize();
      }
    });
  }

  private handleUpdated(updated: apsEvents.CheckListInstancesUpdated) {
    if (!this.list) {
      return;
    }

    if (updated.instances.length > 0) {
      _.forEach(updated.instances, i => this.handleUpdated(i));
    }

    var existing = _.find(this.list, {id: updated.id});
    if (!existing) {
      return;
    }

    this.$timeout(() => {
      if (updated.action === apsEnums.EventAction.Delete
        || updated.status === apsEnums.CheckListStatus.Pending
        || updated.status === apsEnums.CheckListStatus.Complete) {
        _.remove(this.list, existing);
      } else {
        existing.status = updated.status;
        existing.result = updated.result;
      }
    });
  }

  private handleNewInstance(instance: apsViewModels.CheckListInstanceItemEvent): boolean {
    if (instance.status === apsEnums.CheckListStatus.Complete
      || instance.status === apsEnums.CheckListStatus.Pending
      || instance.checkListIsGroup) {
      return false;
    }

    this.list.push(instance);
    return true;
  }

  private handleInstance(instance: apsViewModels.CheckListInstanceItemEvent) {
    if (!this.list) {
      return;
    }

    if (instance.instances.length > 0) {
      _.forEach(instance.instances, i => this.handleInstance(i));
    }

    this.$timeout(() => {
      if (instance.action === apsEnums.EventAction.Add) {
        if (!this.handleNewInstance(instance)) {
          return;
        }
      } else {
        var existing = _.find(this.list, {id: instance.id});
        if (!existing) {
          if (!this.handleNewInstance(instance)) {
            return;
          }
        } else if (instance.status === apsEnums.CheckListStatus.Complete
          || instance.status === apsEnums.CheckListStatus.Pending) {
          _.remove(this.list, existing);
        } else {
          existing.status = instance.status;
          existing.result = instance.result;
        }
      }
    });
  }

  formatTime(time) {
    return DateUtilityService.formatTime(time, this.timeZoneId);
  }

  getStatusName(status: apsEnums.CheckListStatus) {
    return _.startCase(apsEnums.CheckListStatus[status]);
  }

  open(checkListInstance: apsViewModels.CheckListInstanceListItem) {
    var result = openFillOutCheckList({
      checkListId: checkListInstance.checkListId,
      instanceId: checkListInstance.id,
      plantId: checkListInstance.plantId,
      tankId: checkListInstance.tankId,
      shopId: checkListInstance.shopId,
      plantLocationId: checkListInstance.plantLocationId,
      readOnly: false,
      scheduledOn: checkListInstance.scheduledOn
    }, this.$modal);

    result.then((cmd) => {
      var data = {
        status: checkListInstance.status,
        result: apsEnums.CheckListResult.Incomplete
      };
      this.checkListInstancesService.updateStatusAndResult(data, cmd);
      if (data.status === apsEnums.CheckListStatus.Complete) {
        _.remove(this.list, checkListInstance);
      }
    });
  }
}

export default angular.module('aps.controller.unfinishedCheckLists', requires)
  .controller('UnfinishedCheckListsCtrl', UnfinishedCheckListsCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/checks/unfinishedCheckLists.controller.ts